import { useTranslation } from "react-i18next";
import useModuleSelect from "src/Modules/MainMenu/useModuleSelect";
import { SubMenuItem } from "src/constants/modules";
import Section from "./components/Section/Section";
import BrowseHeader from "./components/BrowseHeader/BrowseHeader";
import { SECTIONS, SectionTitle, SectionEntry } from "./constants";
import { Divider } from "antd";

export default function LandingContent() {
  const { t } = useTranslation();
  const { items } = useModuleSelect();

  const sections = (Object.entries(SECTIONS) as [SectionTitle, SectionEntry][]).map(([title, { icon, modules }]) => ({
    title,
    icon,
    items: modules.map(({ type }) => items.find((item) => item.type === type)).filter((item): item is SubMenuItem => Boolean(item)),
  }));

  return (
    <div className="flex w-full flex-col overflow-hidden gap-4 p-2 lg:p-5 lg:px-10 font-inter">
      <BrowseHeader />
      <Divider className="m-4!"/>
      <div className="bg-background-default relative z-10 -mt-6 flex items-center justify-start rounded-t-xl md:mt-0 md:rounded-none">
        <div className="divide-border-default flex w-full flex-col gap-4 divide-y rounded-xl">
          {sections.map((section, index) => (
            <Section
              icon={section.icon}
              key={section.title}
              title={t(`Landing.sections.${section.title}.title`)}
              items={section.items}
              index={index}
              subtitle={t(`Landing.sections.${section.title}.subtitle`)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
